import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

/*引入rem*/
/*import "@/assets/js/rem";*/

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 50000
//设置api地址
//全局定义axios
// axios.defaults.baseURL = 'http://ytky.dev.fxwljy.com'
Vue.prototype.$http = axios

// 图片服务器地址
Vue.prototype.imgserver = ''
// echarts插件
import * as echarts from "echarts";
import * as echartsGL from 'echarts-gl'
import jquery from 'jquery'
Vue.prototype.$ = jquery
// vue全局注入Echarts
Vue.prototype.$echarts = echarts
Vue.prototype.$echartsGL = echartsGL

import world from 'echarts/map/json/world.json';
import china from '../src/assets/json/china.json';
echarts.registerMap('world', world)
echarts.registerMap('china', china)

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  loading: '', // 加载时显示的图片路径
})


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')